<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>CPR nummer</label>
        <app-let-input-cpr formControlName="cpr" />
      </div>
      <div class="control">
        <label>Navn</label>
        <input pInputText formControlName="navn" />
      </div>
      <div class="control">
        <label>Regnr</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>Email</label>
        <input pInputText formControlName="email" />
      </div>
      <div class="control">
        <label>Mobil</label>
        <input pInputText formControlName="mobil" />
      </div>
      <div class="control">
        <label>Fastnet</label>
        <input pInputText formControlName="fastnet" />
      </div>
      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="kundeService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
